import type { SVGProps } from 'react';

const SvgMegaphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.12 14.36 17.25 3.74a.98.98 0 0 0-.61-.67c-.3-.11-.64-.08-.91.1L7.96 8.32l-2.74.74c-1.6.43-2.55 2.08-2.12 3.68l.26.97a3 3 0 0 0 2.9 2.22c.26 0 .52-.03.78-.1l1.04 3.86c.24.89 1.05 1.48 1.93 1.48.17 0 .35-.02.52-.07l1.14-.31c.92-.25 1.54-1.12 1.47-2.06l-.23-3.46 6.17.36h.06c.3 0 .59-.13.78-.37.2-.25.27-.58.19-.89zM5.3 13.18l-.26-.97c-.14-.53.17-1.08.7-1.23l1.93-.52.66 2.43.13.47-1.93.52c-.53.14-1.08-.17-1.23-.7m5.86 5.67-1.14.31-1.04-3.86.81-.22 1.13.07.25 3.71zm-.7-5.74-.93-3.44 6.15-4.08 2.15 7.94-7.37-.43z"
    />
  </svg>
);
export default SvgMegaphone;
